<ng-container *transloco="let t">
<ng-template #income>
  @if (inEditMode) {
    <div class="d-flex mb-5">
      <div class="col-sm-6 col-form-label fw-bold fs-6 editor-label">{{ t('wizard.income.enforce2YearsEmployment') }}</div>
      <div class="col-sm-2 form-check form-switch form-check-custom form-check-solid">
        <input class="form-check-input h-20px w-30px" type="checkbox" name="enforceAtLeast2YearsOfEmploymentHistory"
          id="enforceAtLeast2YearsOfEmploymentHistory" [(ngModel)]="enforce2Years" />
        <label class="form-check-label" for="enforceAtLeast2YearsOfEmploymentHistory">
          {{enforce2Years ? t('common.yes') : t('common.no')}}
        </label>
      </div>
    </div>
  }
  @if (mainBorrower) {
    <div class="fv-row" id="income-main">
      @if (mainBorrower.employments.length > 0 || mainBorrower.nonEmploymentIncomes.length > 0) {
        <div class="card shadow-sm mb-5">
          <div class="card-header">
            <h3 class="card-title">{{mainBorrower.firstName + " " + mainBorrower.lastName}}</h3>
            <span class="duration-indicator" [ngClass]="{'not-enough-history': enforce2Years && !borrowerEmploymentInfoByBorrowerId.get(mainBorrower.borrowerId).isRetired &&
              !borrowerEmploymentInfoByBorrowerId.get(mainBorrower.borrowerId).hasQualifiedIncomeForBypass &&
              borrowerEmploymentInfoByBorrowerId.get(mainBorrower.borrowerId).numberOfMonthsEmployed < 24,
              'enough-history': (enforce2Years && !borrowerEmploymentInfoByBorrowerId.get(mainBorrower.borrowerId).isRetired &&
                !borrowerEmploymentInfoByBorrowerId.get(mainBorrower.borrowerId).hasQualifiedIncomeForBypass &&
                borrowerEmploymentInfoByBorrowerId.get(mainBorrower.borrowerId).numberOfMonthsEmployed >= 24)}">
              {{borrowerEmploymentInfoByBorrowerId.get(mainBorrower.borrowerId).numberOfMonthsEmployed|
              monthsToYearsAndMonths}}
            </span>
          </div>
          <div class="card-body card-body-mobile">
            <borrower-income #borrowerIncome [fieldConfig]="step.fieldConfig" [borrower]="mainBorrower"
              [borrowers]="inCoApplyFlow ? [currentBorrower] : getBorrowersAppliedFor()"
              (incomesChanged)="onIncomesChanged()">
            </borrower-income>
          </div>
        </div>
      }

      @if (!inCoApplyFlow) {
        @for (borrower of coBorrowers; track borrower.borrowerId) {
          @if (borrowerSetting(borrower) && (borrower.employments.length > 0 || borrower.nonEmploymentIncomes.length > 0)) {
            <div class="card shadow-sm mb-5">
              <div class="card-header">
                <h3 class="card-title">{{borrower.firstName + " " + borrower.lastName}}</h3>
                <span class="duration-indicator" [ngClass]="{'not-enough-history': enforce2Years && !borrowerEmploymentInfoByBorrowerId.get(borrower.borrowerId).isRetired &&
                    !borrowerEmploymentInfoByBorrowerId.get(borrower.borrowerId).hasQualifiedIncomeForBypass &&
                    borrowerEmploymentInfoByBorrowerId.get(borrower.borrowerId).numberOfMonthsEmployed < 24,
                    'enough-history': (enforce2Years && !borrowerEmploymentInfoByBorrowerId.get(borrower.borrowerId).isRetired &&
                      !borrowerEmploymentInfoByBorrowerId.get(borrower.borrowerId).hasQualifiedIncomeForBypass &&
                      borrowerEmploymentInfoByBorrowerId.get(borrower.borrowerId).numberOfMonthsEmployed >= 24)}">
                  {{borrowerEmploymentInfoByBorrowerId.get(borrower.borrowerId).numberOfMonthsEmployed|
                  monthsToYearsAndMonths}}
                </span>
              </div>
              <div class="card-body">
                <borrower-income #borrowerIncome [fieldConfig]="step.fieldConfig" [borrower]="borrower"
                  [borrowers]="inCoApplyFlow ? [currentBorrower] : getBorrowersAppliedFor()"
                  (incomesChanged)="onIncomesChanged()">
                </borrower-income>
              </div>
            </div>
          }
        }
      }
      <div class="row mt-10 hidden-when-mobile">
        <div class="col-xl-12 mb-6">
          <div class="row g-9" data-kt-buttons="true" data-kt-buttons-target="[data-kt-button]">
            <div class="col-md-3 col-lg-3 col-xxl-3">
              <label (click)="onW2BasedEmploymentClicked()"
                class="btn btn-outline btn-outline-dashed btn-outline-default p-4 d-flex align-items-center option-text"
                style="min-height: 80px;" for="militaryPay">
                <span class="svg-icon svg-icon-2x me-5">
                  <duotone-shirt-svg-icon></duotone-shirt-svg-icon>
                </span>
                <span class="d-block fw-bold text-start">
                  @if (!inEditMode) {
                    <span class="text-dark fw-bolder d-block fs-5">{{ config | localizedLabel:'w2EmploymentActionLabel':'wizard.income.employmentW2' }}</span>
                  }
                  @if (inEditMode) {
                    <input name="employmentW2ActionLabel" type="text"
                      class="form-control form-control-solid fs-5 fw-bolder"
                      [ngModel]="i18n.get(config, 'w2EmploymentActionLabel')"
                      (ngModelChange)="i18n.set(config, 'w2EmploymentActionLabel', $event)"
                      [placeholder]="config | localizedLabel:'w2EmploymentActionLabel':'wizard.income.employmentW2'" />
                  }
                  <span class="text-gray-400 fw-bold fs-6"></span>
                </span>
              </label>
            </div>
            <div class="col-md-3 col-lg-3 col-xxl-3">
              <label (click)="onSelfEmploymentClicked()"
                class="btn btn-outline btn-outline-dashed btn-outline-default p-4 d-flex align-items-center option-text"
                style="min-height: 80px;" for="militaryPay">
                <span class="svg-icon svg-icon-2x me-5">
                  <duotone-safe-svg-icon></duotone-safe-svg-icon>
                </span>
                <span class="d-block fw-bold text-start">
                  @if (!inEditMode) {
                    <span class="text-dark fw-bolder d-block fs-5">{{ config | localizedLabel:'businessSelfEmploymentActionLabel':'wizard.income.businessSelfEmployment' }}</span>
                  }
                  @if (inEditMode) {
                    <input name="businessSelfEmploymentActionLabel" type="text"
                      class="form-control form-control-solid fs-5 fw-bolder"
                      [ngModel]="i18n.get(config, 'businessSelfEmploymentActionLabel')"
                      (ngModelChange)="i18n.set(config, 'businessSelfEmploymentActionLabel', $event)"
                      [placeholder]="config | localizedLabel:'businessSelfEmploymentActionLabel':'wizard.income.businessSelfEmployment'" />
                  }
                  <span class="text-gray-400 fw-bold fs-6"></span>
                </span>
              </label>
            </div>
            <!-- <div class="col-md-3 col-lg-3 col-xxl-3">
              <label (click)="onIndependentContractorClicked()"
                class="btn btn-outline btn-outline-dashed btn-outline-default p-4 d-flex align-items-center option-text"
                style="min-height: 80px;" for="militaryPay">
                <span class="svg-icon svg-icon-2x me-5">
                  <duotone-tools-svg-icon></duotone-tools-svg-icon>
                </span>
                <span class="d-block fw-bold text-start">
                  @if (!inEditMode) {
                    <span class="text-dark fw-bolder d-block fs-5">{{ step.independentContractorActionLabel || 'Independent Contractor'}}</span>
                  }
                  @if (inEditMode) {
                    <input name="independentContractorActionLabel" type="text"
                      class="form-control form-control-solid fs-5 fw-bolder"
                      [ngModel]="i18n.get(config, 'independentContractorActionLabel')"
                      (ngModelChange)="i18n.set(config, 'independentContractorActionLabel', $event)"
                      [placeholder]="i18n.basePlaceholder(step, 'independentContractorActionLabel')" />
                  }
                  <span class="text-gray-400 fw-bold fs-6"></span>
                </span>
              </label>
            </div> -->
            <div class="col-md-3 col-lg-3 col-xxl-3">
              <!-- <input type="radio" [checked]="option.selected" class="btn-check" (click)="onOptionSelected(option)" name="{{option.name}}" value="{{option.value}}" id="{{option.name}}" /> -->
              <label (click)="onMilitaryPayClicked()"
                class="btn btn-outline btn-outline-dashed btn-outline-default p-4 d-flex align-items-center option-text"
                style="min-height: 80px;" for="militaryPay">
                <span class="svg-icon svg-icon-2x me-5">
                  <duotone-star-svg-icon></duotone-star-svg-icon>
                </span>
                <span class="d-block fw-bold text-start">
                  @if (!inEditMode) {
                    <span class="text-dark fw-bolder d-block fs-5">{{ config | localizedLabel:'militaryPayActionLabel':'wizard.income.militaryPay' }}</span>
                  }
                  @if (inEditMode) {
                    <input name="militaryPayActionLabel" type="text"
                      class="form-control form-control-solid fs-5 fw-bolder"
                      [ngModel]="i18n.get(config, 'militaryPayActionLabel')"
                      (ngModelChange)="i18n.set(config, 'militaryPayActionLabel', $event)"
                      [placeholder]="config | localizedLabel:'militaryPayActionLabel':'wizard.income.militaryPay'" />
                  }
                  <span class="text-gray-400 fw-bold fs-6"></span>
                </span>
              </label>
            </div>
            <div class="col-md-3 col-lg-3 col-xxl-3">
              <label (click)="onRentalIncomeClicked()"
                class="btn btn-outline btn-outline-dashed btn-outline-default p-4 d-flex align-items-center option-text"
                style="min-height: 80px;" for="militaryPay">
                <span class="svg-icon svg-icon-2x me-5">
                  <duotone-home-svg-icon></duotone-home-svg-icon>
                </span>
                <span class="d-block fw-bold text-start">
                  @if (!inEditMode) {
                    <span class="text-dark fw-bolder d-block fs-5">{{ config | localizedLabel:'rentalIncomeActionLabel':'wizard.income.rental' }}</span>
                  }
                  @if (inEditMode) {
                    <input name="rentalIncomeActionLabel" type="text"
                      class="form-control form-control-solid fs-5 fw-bolder"
                      [ngModel]="i18n.get(config, 'rentalIncomeActionLabel')"
                      (ngModelChange)="i18n.set(config, 'rentalIncomeActionLabel', $event)"
                      [placeholder]="config | localizedLabel:'rentalIncomeActionLabel':'wizard.income.rental'" />
                  }
                  <span class="text-gray-400 fw-bold fs-6"></span>
                </span>
              </label>
            </div>
          </div>
        </div>
        <div class="col-xl-12">
          <div class="row g-9">
            <div class="col-md-3 col-lg-3 col-xxl-3">
              <label (click)="onPensionClicked()"
                class="btn btn-outline btn-outline-dashed btn-outline-default p-4 d-flex align-items-center option-text"
                style="min-height: 80px;" for="militaryPay">
                <span class="svg-icon svg-icon-2x me-5">
                  <duotone-dollar-svg-icon></duotone-dollar-svg-icon>
                </span>
                <span class="d-block fw-bold text-start">
                  @if (!inEditMode) {
                    <span class="text-dark fw-bolder d-block fs-5">{{ config | localizedLabel:'pensionIncomeActionLabel':'wizard.income.pension' }}</span>
                  }
                  @if (inEditMode) {
                    <input name="pensionIncomeActionLabel" type="text"
                      class="form-control form-control-solid fs-5 fw-bolder"
                      [ngModel]="i18n.get(config, 'pensionIncomeActionLabel')"
                      (ngModelChange)="i18n.set(config, 'pensionIncomeActionLabel', $event)"
                      [placeholder]="config | localizedLabel:'pensionIncomeActionLabel':'wizard.income.pension'" />
                  }
                  <span class="text-gray-400 fw-bold fs-6"></span>
                </span>
              </label>
            </div>
            <div class="col-md-3 col-lg-3 col-xxl-3">
              <label (click)="onSocialSecurityClicked()"
                class="btn btn-outline btn-outline-dashed btn-outline-default p-4 d-flex align-items-center option-text"
                style="min-height: 80px;" for="militaryPay">
                <span class="svg-icon svg-icon-2x me-5">
                  <duotone-bank-svg-icon></duotone-bank-svg-icon>
                </span>
                <span class="d-block fw-bold text-start">
                  @if (!inEditMode) {
                    <span class="text-dark fw-bolder d-block fs-5">{{ config | localizedLabel:'socialSecurityIncomeActionLabel':'wizard.income.socialSecurity' }}</span>
                  }
                  @if (inEditMode) {
                    <input name="socialSecurityIncomeActionLabel" type="text"
                      class="form-control form-control-solid fs-5 fw-bolder"
                      [ngModel]="i18n.get(config, 'socialSecurityIncomeActionLabel')"
                      (ngModelChange)="i18n.set(config, 'socialSecurityIncomeActionLabel', $event)"
                      [placeholder]="config | localizedLabel:'socialSecurityIncomeActionLabel':'wizard.income.socialSecurity'" />
                  }
                  <span class="text-gray-400 fw-bold fs-6"></span>
                </span>
              </label>
            </div>
            <div class="col-md-3 col-lg-3 col-xxl-3">
              <label (click)="onOtherIncomeClicked()"
                class="btn btn-outline btn-outline-dashed btn-outline-default p-4 d-flex align-items-center option-text"
                style="min-height: 80px;" for="militaryPay">
                <span class="svg-icon svg-icon-2x me-5">
                  <duotone-wallet-svg-icon></duotone-wallet-svg-icon>
                </span>
                <span class="d-block fw-bold text-start">
                  @if (!inEditMode) {
                    <span class="text-dark fw-bolder d-block fs-5">{{ config | localizedLabel:'otherIncomeActionLabel':'wizard.income.other' }}</span>
                  }
                  @if (inEditMode) {
                    <input name="otherIncomeActionLabel" type="text"
                      class="form-control form-control-solid fs-5 fw-bolder"
                      [ngModel]="i18n.get(config, 'otherIncomeActionLabel')"
                      (ngModelChange)="i18n.set(config, 'otherIncomeActionLabel', $event)"
                      [placeholder]="config | localizedLabel:'otherIncomeActionLabel':'wizard.income.other'" />
                  }
                  <span class="text-gray-400 fw-bold fs-6"></span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>

      @if (!addingIncome) {
        <div class="row mt-10 hidden-when-not-mobile">
          <div class="col-md-12">
            <div class="d-flex justify-content-center ">
              <label (click)="onAddIncomeClicked()"
                class="btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center">
                <span class="svg-icon svg-icon-2x me-5 duotone-home-svg-mobile" style="margin-top: -4px;">
                  <duotone-home-svg-icon></duotone-home-svg-icon>
                </span>
                <span class="d-block fw-bold text-start">
                  <span class="text-dark fw-bolder d-block fs-5 mb-2">{{ t('wizard.income.addIncome') }}</span>
                  <span class="text-gray-400 fw-bold fs-6"></span>
                </span>
              </label>
            </div>
          </div>
        </div>
      }
      @if (addingIncome) {
        <div class="row mt-10 hidden-when-not-mobile d-flex">
          <div class="col-md-12 d-flex">
            <form class="form w-100" #incomeForm="ngForm" novalidate id="incomeForm" name="incomeForm">
              <label class="form-label required">{{ t('wizard.income.typeOfIncome') }}</label>
              <div class="d-flex">
                <select class="form-select form-select-solid me-2" data-control="select2" name="typeOfIncome"
                  #typeOfIncomeControl="ngModel" [(ngModel)]="selectedTypeOfIncome" (ngModelChange)="onTypeOfIncomeChanged()"
                  [ngClass]="{'is-invalid' : typeOfIncomeControl && typeOfIncomeControl.touched && typeOfIncomeControl.invalid}"
                  required>
                  <option [ngValue]="null" disabled>{{ t('common.selectOne') }}</option>
                  @for (typeOfIncome of typesOfIncome; track typeOfIncome.value) {
                    <option [value]="typeOfIncome.value">
                      {{ config | localizedLabel:typeOfIncome.labelField:typeOfIncome.i18nKey }}</option>
                  }
                </select>
                <button type="button" class="btn btn-lg btn-light-primary me-3" (click)="addingIncome = false;">
                  {{ t('common.cancel') }}
                </button>
              </div>
            </form>
          </div>
        </div>
      }
    </div>
  }
</ng-template>

<wizard-step-template [stepMainTemplate]="income" [step]="step" [stepComponent]="this"></wizard-step-template>
</ng-container>
